/** Filtry zestawień (z adresu strony) i ich zapis jako parametry zapytania API. */
export interface Filters {
  from: string;
  to: string;
  companyId?: string;
  tradeCode?: string;
  ownerId?: string;
}

export const toQuery = (f: Partial<Filters>) => {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(f)) if (v) q.set(k, v);
  return q.toString();
};
